export default "__VITE_ASSET__COcxN2oH__"